import type { SingleGameFragment } from "@workspace/casino_core/fragments/SingleGameFragment";
import GameDetailsRow from "./shared/GameDetailsRow";

type Props = Pick<SingleGameFragment, "rtp">;

const RtpRow: FC<Props> = ({ rtp }) => {
  if (!rtp) {
    return null;
  }
  return <GameDetailsRow translateId="casino.rtp">{rtp}%</GameDetailsRow>;
};

export default RtpRow;
